import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

// Old route → merged page, keeping any existing query string (e.g. ?page=2)
// and adding the tab/section the legacy page now lives under.
export default function LegacyRedirect({ to, tab, section }) {
  const location = useLocation();
  const p = new URLSearchParams(location.search);
  if (tab) p.set('tab', tab);
  if (section) p.set('section', section);
  const qs = p.toString();
  return <Navigate to={`${to}${qs ? `?${qs}` : ''}${location.hash || ''}`} replace />;
}
